import Cookies from 'js-cookie';

const user = {
    state: {},
    mutations: {
        logout (state, vm) {
            Cookies.remove('user');
            Cookies.remove('password');
            Cookies.remove('access');
            // 恢复默认样式
            // let themeLink = document.querySelector('link[name="theme"]');
            // themeLink.setAttribute('href', '');
            // 清空打开的页面等数据，但是保存主题数据
            let theme = '';
            let username = localStorage.getItem("userName");
            let password = localStorage.getItem("password");
            if (localStorage.theme) {
                theme = localStorage.theme;
            }
            localStorage.clear();
            if (theme) {
                localStorage.theme = theme;
            }
            if(username != null){
                localStorage.setItem("userName",username);
                localStorage.setItem("password",password);
            }
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js